import { render } from "./PurchaseRegisterView.vue?vue&type=template&id=05080e4d&scoped=true"
import script from "./PurchaseRegisterView.vue?vue&type=script&lang=js"
export * from "./PurchaseRegisterView.vue?vue&type=script&lang=js"

import "./PurchaseRegisterView.vue?vue&type=style&index=0&id=05080e4d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05080e4d"]])

export default __exports__